import { constants } from './constants';
export const setServerBaseUrl = () => {
  let url;
  switch (process.env.REACT_APP_FE_ENV) {
    case 'PROD':
      url = constants.BE_BASE_URL.PROD;
      break;
    case 'STAGE':
      url = constants.BE_BASE_URL.STAGE;
      break;
    case 'TEST':
      url = constants.BE_BASE_URL.TEST;
      break;
    case 'LOCAL':
      url = constants.BE_BASE_URL.LOCAL;
      break;
    case 'LFERBES':
      url = constants.BE_BASE_URL.STAGE;
      break;
    case 'LFERBET':
      url = constants.BE_BASE_URL.TEST;
      break;
    default:
      url = constants.BE_BASE_URL.LOCAL;
      break;
  }
  return url;
};
